import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { HandoffExceptionRequest, IHandoffException } from 'src/app/common/models/handoffException';
import { HandoffType } from 'src/app/common/models/handoffType';
import { StoreHandoffService } from 'src/app/services/store-handoff.service';
import moment from 'moment';
import { FacilityManager } from 'src/app/managers/facility.manager';
import { CdkScrollable } from '@angular/cdk/scrolling';

import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-temporary-exception',
  templateUrl: './temporary-exception.component.html',
  styleUrls: ['./temporary-exception.component.scss'],
  standalone: true,
  imports: [CdkScrollable, MatDialogContent, MatRadioGroup, FormsModule, MatRadioButton, MatButton],
})
export class TemporaryExceptionComponent implements OnInit {
  public toCreate = true;
  public duration = '1';

  constructor(
    public dialogRef: MatDialogRef<TemporaryExceptionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: HandoffType,
    private storeHandoffService: StoreHandoffService,
    private _facilityManager: FacilityManager,
    private toastr: ToastrService,
  ) {}

  public ngOnInit(): void {
    if (this.data.exceptions.length > 0) {
      this.toCreate = false;
    }
  }

  public onNoClick(): void {
    this.dialogRef.close();
  }

  public saveAction(): void {
    if (this.toCreate) {
      const turnOnDate = moment().startOf('day').add(Number.parseInt(this.duration), 'days').format();
      const handoffException: IHandoffException = {
        organizationId: 1,
        facilityId: Number.parseInt(this._facilityManager.getCurrentFacility()),
        handoffType: this.data.handoffType,
        enableOn: turnOnDate,
      };
      this.storeHandoffService.upsertStoreHandoffException(handoffException).subscribe({
        next: (_) => {
          this.toastr.success('Temporary Exception created');
          const handoffExceptionRequest: HandoffExceptionRequest = {
            exceptionStatus: true,
            handoffException: handoffException,
          };
          this.dialogRef.close(handoffExceptionRequest);
        },
        error: (e) => {
          this.toastr.error('Error while Creating Exception');
        },
      });
    }
    if (!this.toCreate) {
      this.storeHandoffService.deleteStoreHandoffException(this.data.exceptions[0]).subscribe({
        next: (_) => {
          this.toastr.success('Temporary Exception removed');
          const handoffExceptionRequest: HandoffExceptionRequest = {
            exceptionStatus: false,
            handoffException: this.data.exceptions[0],
          };
          this.dialogRef.close(handoffExceptionRequest);
        },
        error: (e) => {
          this.toastr.error('Error while Removing Exception');
        },
      });
    }
  }
}
